import app from 'flarum/forum/app';
import FarmPage from './pages/FarmPage';

app.initializers.add('yingtao-forum-farm-game', () => {
  app.routes.yingtaoFarm = { path: '/farm', component: FarmPage };
});
